import { useEffect, useRef } from "react"

export default function useEventListener(
    eventType,
    callback,
    { triggerOnMounted = false, element = window } = {}
) {
    const callbackRef = useRef(callback)

    useEffect(() => {
        callbackRef.current = callback
    }, [callback])

    useEffect(() => {
        if (element == null) return
        const handler = (e) => callbackRef.current(e)
        if (triggerOnMounted) handler()
        element.addEventListener(eventType, handler)
        return () => element.removeEventListener(eventType, handler)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventType, element])
}
